
// Soft UI Dashboard React layouts
import Dashboard from "layouts/dashboard";
import { useTranslation } from "react-i18next";

// Soft UI Dashboard React icons
import Shop from "reusableComponents/Icons/Shop";
import Office from "reusableComponents/Icons/Office";
import Departments from "./mainComponents/departments/Departments";
import Universities from "./mainComponents/universities/Universities";
import Librarians from "./mainComponents/librarians/Librarians";
import { MdGroup } from 'react-icons/md';
import { HiMiniUsers } from "react-icons/hi2";
import ResearcherManagement from "./mainComponents/researcherManagement/ResearcherManagement";
import Document from "./reusableComponents/Icons/Document";
import Report from "./mainComponents/report/Report";
import { BiSolidReport } from "react-icons/bi";
import { FaUniversity } from "react-icons/fa";
import SwaggerDoc from "swagger/swaggerDocs";
import { BsFiletypeJson } from "react-icons/bs";
import ServicesList from "./layouts/services/ServicesList";
import { MdMiscellaneousServices } from "react-icons/md";
import Publications from "./layouts/publications";
import {ALMANDUMA_CUSTOMER, PUBLICATIONS_VIEW} from "./utlis/constant";
import ManageBatches from "./mainComponents/batches/ManageBatches";

export default function sideBarItems() {
    const { t, i18n } = useTranslation('sideNav');
    const currentLang = i18n.language;
    const customerName = window?.appConfig?.REACT_APP_CUSTOMER_NAME || process.env.REACT_APP_CUSTOMER_NAME

    const p = (path) => `/${currentLang}${path}`;

    return {
    'super-admin':
        [
            {
                type: "collapse",
                name: "Dashboard",
                key: "dashboard",
                route: p("/dashboard"),
                icon: <Shop size="12px"/>,
                component: <Dashboard/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Universities list",
                key: "universities-list",
                route: p("/universities-list"),
                icon: <FaUniversity size="12px"/>,
                component: <Universities/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Librarian Admins",
                key: "librarian-admins",
                route: p("/librarian-admins"),
                icon:<MdGroup style={{fontSize: '14px'}} />,
                component: <Librarians/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Digital Databases",
                key: "documents",
                route: p("/documents"),
                icon: <Document size="12px" />,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Report",
                key: "report",
                route: p("/report"),
                icon: <BiSolidReport size="12px"/>,
                component: <Report/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Services List",
                key: "services-list",
                route: p("/services-list"),
                icon: <MdMiscellaneousServices size="12px"/>,
                component: <ServicesList />,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Manage Batches",
                key: "manage-batches",
                route: p("/manage-batches"),
                icon: <MdMiscellaneousServices size="12px"/>,
                component: <ManageBatches />,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: "Swagger docs",
                key: "swagger-docs",
                route: p("/api-docs"),
                icon: <BsFiletypeJson size="14px"/>,
                component: <SwaggerDoc/>,
                noCollapse: true,
            }
        ],
    'librarian':
        [
            {
                type: "collapse",
                name: t('dashboard', {ns:'sideNav'}),
                key: "dashboard",
                route: p("/dashboard"),
                icon: <Shop size="12px"/>,
                component: <Dashboard/>,
                noCollapse: true,
            },
            customerName !== ALMANDUMA_CUSTOMER && {
                type: "collapse",
                name: t('researcher-management', {ns:'sideNav'}),
                key: "researcher-management",
                route: p("/researcher-management"),
                icon: <HiMiniUsers size="12px"/>,
                component: <ResearcherManagement/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('digitalDatabase', {ns:'sideNav'}),
                key: "documents",
                route: p("/documents"),
                icon: <Document size="12px" />,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('my-documents', {ns:'sideNav'}),
                key: "my-documents",
                route: p("/my-documents"),
                icon: <Document size="12px" />,
                element: (
                        <Publications view={PUBLICATIONS_VIEW} />
                ),
                noCollapse: true,
            },
            customerName !== ALMANDUMA_CUSTOMER && {
                type: "collapse",
                name: t('report', {ns:'sideNav'}),
                key: "report",
                route: p("/report"),
                icon: <BiSolidReport size="12px"/>,
                component: <Report/>,
                noCollapse: true,
            },
            customerName !== ALMANDUMA_CUSTOMER && {
                type: "collapse",
                name: t('swaggerDocs', {ns:'sideNav'}),
                key: "swagger-docs",
                route: p("/api-docs"),
                icon: <BsFiletypeJson size="14px"/>,
                component: <SwaggerDoc/>,
                noCollapse: true,
            }
        ],
    'researcher':
        [
            {
                type: "collapse",
                name: t('dashboard', {ns:'sideNav'}),
                key: "dashboard",
                route: p("/dashboard"),
                icon: <Shop size="12px"/>,
                component: <Dashboard/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('digitalDatabase', {ns:'sideNav'}),
                key: "documents",
                route: p("/documents"),
                icon: <Document size="12px" />,
                noCollapse: true,
            },
        ],
    'library-admin':
        [
            {
                type: "collapse",
                name: t('dashboard', {ns:'sideNav'}),
                key: "dashboard",
                route: p("/dashboard"),
                icon: <Shop size="12px"/>,
                component: <Dashboard/>,
                noCollapse: true,
            },
            customerName !== ALMANDUMA_CUSTOMER && {
                type: "collapse",
                name: t('departments-list', {ns:'sideNav'}),
                key: "departments-list",
                route: p("/departments-list"),
                icon: <Office size="12px"/>,
                component: <Departments/>,
                noCollapse: true,
            },
            customerName === ALMANDUMA_CUSTOMER && {
                type: "collapse",
                name: t('user-management', {ns:'sideNav'}),
                key: "user-management",
                route: p("/user-management"),
                icon:<MdGroup style={{fontSize: '14px'}} />,
                component: <Librarians/>,
                noCollapse: true,
            },
            customerName !== ALMANDUMA_CUSTOMER && {
                type: "collapse",
                name: t('librarian-management', {ns:'sideNav'}),
                key: "librarian-management",
                route: p("/librarian-management"),
                icon:<MdGroup style={{fontSize: '14px'}} />,
                component: <Librarians/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t('digitalDatabase', {ns:'sideNav'}),
                key: "documents",
                route: p("/documents"),
                icon: <Document size="12px"/>,
                noCollapse: true,
            },
            {
                type: "collapse",
                name: t("manage-batches", {ns:'sideNav'}),
                key: "manage-batches",
                route: p("/manage-batches"),
                icon: <MdMiscellaneousServices size="12px"/>,
                component: <ManageBatches />,
                noCollapse: true,
            },
            customerName !== ALMANDUMA_CUSTOMER && {
                type: "collapse",
                name: t('report', {ns:'sideNav'}),
                key: "report",
                route: p("/report"),
                icon: <BiSolidReport size="12px"/>,
                component: <Report/>,
                noCollapse: true,
            },
            customerName !== ALMANDUMA_CUSTOMER && {
                type: "collapse",
                name: t('swaggerDocs', {ns:'sideNav'}),
                key: "swagger-docs",
                route: p("/api-docs"),
                icon: <BsFiletypeJson size="14px"/>,
                component: <SwaggerDoc/>,
                noCollapse: true,
            }
        ]
    };
}
